<template>
  <v-container fluid fill-height class="px-0">
    <v-row>
      <v-col>
        <span class="font-weight-bold text-body-1 font-italic">
          Lista de lotes en producción
        </span>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" xl="6" lg="6">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar..."
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="6" lg="6">
        <v-row>
          <v-col cols="auto">
            <v-btn
              color="gray"
              rounded
              small
              block
              dark
              @click="showFiltersLotesModal = true"
            >
              <v-icon>mdi-filter</v-icon>
              Filtrar lotes
            </v-btn>
          </v-col>
          <v-col
            v-if="
              permissions.find(
                (permission) => permission == 'prod_request_strain'
              )
            "
            cols="auto"
          >
            <v-btn
              color="primary"
              rounded
              small
              block
              @click="showNewStrainRequest = true"
            >
              <v-icon> mdi-bacteria </v-icon>
              Solicitar cepa
            </v-btn>
          </v-col>
          <v-col
            v-if="
              permissions.find((permission) => permission == 'prod_new_batch')
            "
            cols="auto"
          >
            <v-btn
              color="primary"
              rounded
              small
              block
              @click="showNewLote = true"
            >
              <v-icon> mdi-package-up </v-icon>
              Nuevo lote
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn small color="primary" rounded @click="refresh" block>
              <v-icon>mdi-refresh</v-icon>
              Refrescar
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              color="primary"
              rounded
              block
              @click="showStockModal = true"
            >
              <v-icon class="pl-1">mdi-chart-bar-stacked</v-icon>
              Visualizar Stock
            </v-btn>
          </v-col>
          <v-col
            v-if="
              permissions.find((permission) => permission == 'prod_supply_op')
            "
            cols="auto"
          >
            <v-btn
              small
              color="primary"
              rounded
              block
              @click="showSupplyModal = true"
            >
              <v-icon class="pl-1">mdi-table-plus</v-icon>
              Surtir OP's
            </v-btn>
          </v-col>
          <v-col
            v-if="
              permissions.find(
                (permission) => permission == 'prod_discard_reactivations'
              )
            "
            cols="auto"
          >
            <v-btn
              color="red"
              rounded
              small
              block
              dark
              @click="showDisposeReactivationsModal = true"
            >
              <v-icon> mdi-delete-variant </v-icon>
              Desechar cajas/tubos
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              rounded
              small
              block
              dark
              @click="showLabelsPrintModal = true"
            >
              <v-icon> mdi-printer-pos-outline </v-icon>
              Impimir etiquetas
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="red"
              rounded
              small
              block
              :disabled="batchesSelected.length == 0"
              :dark="batchesSelected.length != 0"
              @click="showUndoLoteModal = true"
            >
              <v-icon> mdi-trash-can </v-icon>
              Deshacer lotes
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model="batchesSelected"
          fixed-header
          height="550px"
          :headers="headers"
          :items="lotes"
          :items-per-page="10"
          no-data-text="No hay lotes"
          loading-text="Cargando lotes..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          @click:row="rowSelect"
          :item-class="row_classes"
          item-key="_id"
          show-select
        >
          <template #[`item.loteId`]="{ item }">
            <v-row>
              <v-col
                v-if="
                  item.alarmValidation1 ||
                  item.alarmInoculate ||
                  item.alarmValidation2 ||
                  item.alarmRice
                "
              >
                <span class="text-caption pa-2 rounded-lg decrease">{{
                  item.loteId
                }}</span>
              </v-col>
              <v-col v-else>
                <span class="text-caption">{{ item.loteId }}</span>
              </v-col>
              <v-col>
                <v-icon
                  color="primary"
                  v-if="item.lotes && item.lotes.length > 0"
                >
                  mdi-call-split
                </v-icon>
              </v-col>
            </v-row>
          </template>
          <template #[`item.identificationName`]="{ item }">
            <span
              style="font-size: 10px"
              v-if="item.loteType == 'SINGLE' || item.loteType == 'DIVISON'"
              >{{ item.identificationName }}</span
            >

            <span style="font-size: 10px" v-else-if="item.loteType == 'BIO'"
              >Ag Boost</span
            >
          </template>
          <template #[`item.reactivations`]="{ item }">
            <span
              class="text-caption"
              v-if="item.loteType == 'SINGLE' || item.loteType == 'DIVISON'"
            >
              <div v-if="item.reactivations">
                <div v-for="(reac, index) in item.reactivations" :key="index">
                  <span>
                    {{ reac.serialReactivation }}
                  </span>
                  <v-spacer
                    v-if="index + 1 != item.reactivations.length"
                  ></v-spacer>
                </div>
              </div>
            </span>
            <span class="text-caption" v-else>-</span>
          </template>
          <template #[`item.lineState`]="{ item }">
            <span class="text-caption"
              >{{ item.productLine }}{{ item.lineState }}</span
            >
          </template>
          <template #[`item.stock`]="{ item }">
            <span> {{ item.stock }} </span>
          </template>
          <template #[`item.manualStock`]="{ item }">
            <span class="selectable_label" @click="openStockModal(item)">
              {{ item.manualStock || 0 }}
            </span>
          </template>
          <template #[`item.presentation`]="{ item }">
            <span class="text-caption" v-if="item.presentation">{{
              item.presentation
            }}</span>
            <span class="text-caption">No disponible</span>
          </template>
          <template #[`item.dosesStart`]="{ item }">
            <span class="text-caption">{{ item.dosesStart }}</span>
          </template>
          <template #[`item.dosesEnd`]="{ item }">
            <span class="text-caption">{{ item.dosesEnd }}</span>
          </template>
          <template #[`item.reactivationDate`]="{ item }">
            <span style="font-size: 10px">{{
              dateFormatShort(item.reactivationDate)
            }}</span>
          </template>
          <template #[`item.spore_date`]="{ item }">
            <span style="font-size: 10px">{{
              dateFormatShort(item.spore_date)
            }}</span>
          </template>
          <template #[`item.deliveryDate`]="{ item }">
            <span style="font-size: 10px">{{
              dateFormatShort(item.deliveryDate)
            }}</span>
          </template>
          <template #[`item.productionState`]="{ item }">
            <div v-if="item.productionState == 'SIFTING'">
              <v-btn color="#dadada" rounded x-small> Molido/Tamizado</v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
              
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'DRYING'">
              <v-btn color="#dadada" rounded x-small> Secado</v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'INCUBATING'">
              <v-btn color="#dadada" rounded x-small> Incubación</v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-else-if="item.productionState == '1_VALIDATION'">
              <v-btn color="#dadada" rounded x-small> 1ra validación </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                1ra validación
              </span> -->
            </div>
            <div v-else-if="item.productionState == '2_VALIDATION'">
              <v-btn color="#dadada" rounded x-small> 2da validación </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
               
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'STOCK'">
              <v-btn color="#fbc02d" dark rounded x-small>
                Stock de espora</v-btn
              >
              <!-- <span class="text-caption pa-2 rounded-lg stockSpore">
           
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'STOCK_PT'">
              <v-btn color="#fbc02d" dark rounded x-small> Almacen PT </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg stockSpore">
                
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'PREINOCULATE'">
              <v-btn color="#dadada" rounded x-small> Preinóculo </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg finish">
                
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'CONTAMINATED'">
              <v-btn color="red" rounded x-small dark> Contaminado</v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg decrease">
                
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'USELESS'">
              <v-btn color="red" rounded x-small dark> Lote desechado </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg decrease">
                Lote desechado
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'DISCARDED'">
              <v-btn color="red" rounded x-small> Lote desechado </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg decrease">
               
              </span> -->
            </div>
            <div v-else-if="item.productionState == 'INOCULATE'">
              <v-btn color="#dadada" rounded x-small> Inóculo </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>

            <div v-if="item.productionState == 'GRINDING'">
              <v-btn color="#dadada" rounded x-small> Molienda </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-if="item.productionState == 'FERMENTATION'">
              <v-btn color="#dadada" rounded x-small> Fermentación </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-if="item.productionState == 'DIGESTION'">
              <v-btn color="#dadada" rounded x-small> Digestión </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-if="item.productionState == 'FORMULATION'">
              <v-btn color="#04c105" dark rounded x-small>
                Formulación/Envasado
              </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg finish">
               
              </span> -->
            </div>
            <div v-if="item.productionState == 'SEED'">
              <v-btn color="#dadada" rounded x-small> Semilla </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
                
              </span> -->
            </div>
            <div v-if="item.productionState == 'FEEDABLE'">
              <v-btn color="#dadada" rounded x-small> Realimentación </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg comonstate">
          
              </span> -->
            </div>
            <div v-if="item.productionState == 'BATCH_CREATED'">
              <v-btn color="#04c105" dark rounded x-small> Lote creado </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg finish">
               
              </span> -->
            </div>
            <div v-if="item.productionState == 'FLASK_VALIDATED'">
              <v-btn color="#dadada" rounded x-small>
                Matraces validados
              </v-btn>
              <!-- <span class="text-caption pa-2 rounded-lg finish">
               
              </span> -->
            </div>
          </template>
          <template #[`item.orders`]="{ item }">
            <v-tooltip bottom v-if="item.orders">
              <template v-slot:activator="{ on, attrs }">
                <span class="text-caption green-text" v-bind="attrs" v-on="on">
                  {{ item.orders.length }}
                </span>
              </template>
              <span>OP's relacionadas</span>
            </v-tooltip>

            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <span class="text-caption green-text" v-bind="attrs" v-on="on">
                  0
                </span>
              </template>
              <span>OP's no relacionadas</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
        ></v-pagination>
      </v-col>
    </v-row>
    <NewStrainRequest
      v-model="showNewStrainRequest"
      v-if="showNewStrainRequest"
    />
    <NewLote v-model="showNewLote" v-if="showNewLote" />
    <FiltersLotesModal v-model="showFiltersLotesModal" @filter="filtering" />
    <StockModal v-model="showStockModal" v-if="showStockModal" />
    <SupplyModal v-model="showSupplyModal" v-if="showSupplyModal" />
    <DisposeReactivationsModal
      v-model="showDisposeReactivationsModal"
      v-if="showDisposeReactivationsModal"
    />
    <update-stock-lote-modal v-model="showUpdateStockLoteModal" />
    <labels-print-modal
      v-model="showLabelsPrintModal"
      v-if="showLabelsPrintModal"
    />
    <undo-lote-modal
      v-model="showUndoLoteModal"
      :lotes="batchesSelected"
      @confirm="handleUndoLote"
    />
  </v-container>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
// date library
import dayjs from "dayjs";
//components
import NewStrainRequest from "@/components/dashboard/lote/modals/NewStrainRequest.vue";
import NewLote from "@/components/dashboard/lote/modals/NewLote.vue";
import StockModal from "@/components/dashboard/lote/modals/StockModal.vue";
import FiltersLotesModal from "@/components/dashboard/lote/modals/FiltersLotesModal.vue";
import SupplyModal from "@/components/dashboard/lote/modals/SupplyModal.vue";
import DisposeReactivationsModal from "@/components/dashboard/lote/modals/DisposeReactivationsModal.vue";
import UpdateStockLoteModal from "./modals/UpdateStockLoteModal.vue";
import LabelsPrintModal from "./modals/LabelsPrintModal.vue";
import UndoLoteModal from "./modals/UndoLoteModal.vue";

export default {
  components: {
    NewStrainRequest,
    NewLote,
    FiltersLotesModal,
    StockModal,
    SupplyModal,
    DisposeReactivationsModal,
    UpdateStockLoteModal,
    LabelsPrintModal,
    UndoLoteModal,
  },
  data: () => ({
    search: null,
    headers: [
      {
        text: "Lote",
        align: "start",
        value: "loteId",
        sortable: false,
      },
      {
        text: "Microorganismo",
        value: "identificationName",
        sortable: false,
      },
      {
        text: "Reactivación",
        align: "center",
        value: "reactivations",
        sortable: false,
      },
      {
        text: "Linea",
        align: "center",
        value: "lineState",
        sortable: false,
      },
      // {
      //   text: "Presentación",
      //   align: "center",
      //   value: "presentation",
      //   sortable: false,
      // },
      {
        text: "Dosis incial",
        align: "center",
        value: "dosesStart",
        sortable: false,
      },
      {
        text: "Dosis final",
        align: "center",
        value: "dosesEnd",
        sortable: false,
      },
      {
        text: "Fecha reactivación",
        align: "center",
        value: "reactivationDate",
        sortable: false,
      },
      {
        text: "Stock (Dosis)",
        align: "center",
        value: "stock",
        sortable: false,
      },
      {
        text: "Stock Manual (Dosis)",
        align: "center",
        value: "manualStock",
        sortable: false,
      },
      {
        text: "Entrega",
        align: "center",
        value: "deliveryDate",
        sortable: false,
      },
      {
        text: "Etapa",
        align: "center",
        value: "productionState",
        sortable: false,
      },
      // { text: "OP ID", align: "center", value: "orders", sortable: false },
    ],
    lotes: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
    showNewStrainRequest: false,
    showNewLote: false,
    showFiltersLotesModal: false,
    showStockModal: false,
    showSupplyModal: false,
    showDisposeReactivationsModal: false,
    filters: null,
    expanded: [],
    user: JSON.parse(localStorage.getItem("user")),
    permissions: [],
    batchesSelected: [],
    showUndoLoteModal: false,
    // modals
    showUpdateStockLoteModal: false,
    showLabelsPrintModal: false,
  }),
  async mounted() {
    let permissions = localStorage.getItem("permissions");
    this.permissions = permissions.split(",");
    await this.fetchData();
  },
  methods: {
    ...mapActions("lotes", ["getLotes", "undoBatch"]),
    ...mapMutations("lotes", ["SET_FETCH_LOTES_LIST", "SET_LOTE_SELECTED"]),
    async requestStrain() {
      this.$router.push(`/cepario-production`);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    rowSelect(rowValue) {
      this.lotes = this.lotes.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });

      this.SET_LOTE_SELECTED(rowValue);
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async refresh() {
      this.SET_LOTE_SELECTED(null);
      await this.fetchData();
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getLotes({
          page: this.page,
          search: this.search,
          filters: this.filters,
        });
        if (response) {
          if (!response.error) {
            if (response.lotes.length > 0) {
              if (!this.loteSelected) {
                for (let item of response.lotes) {
                  item.clicked = false;
                }
                response.lotes[0].clicked = true;
                this.SET_LOTE_SELECTED(response.lotes[0]);
              } else {
                for (let item of response.lotes) {
                  if (this.loteSelected._id == item._id) {
                    item.clicked = true;
                  } else {
                    item.clicked = false;
                  }
                }
              }
            }

            this.lotes = response.lotes;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar lotes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar lotes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar lotes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    async filtering(value) {
      this.page = 1;
      this.filters = value;
      await this.fetchData();
    },
    openStockModal(item) {
      this.rowSelect(item);
      this.showUpdateStockLoteModal = true;
    },
    async handleUndoLote() {
      try {
        let lotes = this.batchesSelected.map((item) => item._id);
        let payload = {
          loteList: lotes,
        };
        await this.undoBatch(payload);

        this.$swal({
          icon: "success",
          title: `Lote(s) deshecho(s)`,
          showConfirmButton: false,
          timer: 2000,
        });
        await this.fetchData();
        this.batchesSelected = [];
        this.showUndoLoteModal = false;
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar lotes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
  watch: {
    async search() {
      this.SET_LOTE_SELECTED(null);
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      this.SET_LOTE_SELECTED(null);
      await this.fetchData();
    },

    async fetchLotesList(value) {
      if (value) {
        await this.fetchData();
        this.SET_FETCH_LOTES_LIST(false);
      }
    },
  },
  computed: {
    ...mapState("lotes", ["fetchLotesList", "loteSelected"]),
  },
};
</script>

<style scoped>
.finish {
  background-color: #04c105;
  color: white;
}

.comonstate {
  background-color: #dadada;
  color: black;
}

.decrease {
  background-color: red;
  color: white;
}

.stockSpore {
  background-color: #fbc02d;
  color: white;
}

.custom-highlight-row {
  background-color: rgba(4, 193, 5, 0.13);
  font-weight: bold;
}

.selectable_label:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #04c105;
}
</style>
